module.exports = __webpack_public_path__ + "img/logo_bidipay_texto.7e66fd07.png";